module.exports = __webpack_public_path__ + "img/03s.eeef66e9.webp";